<template>
<div>
    <v-progress-circular v-if="this.saving"
        indeterminate
        color="green"
      ></v-progress-circular>

    <v-row no-gutters class="pa-0" v-if="!raz4">
      <v-col cols="12" sm="12" md="12" xs="12" lg="10" xl="10">
        <v-autocomplete
          :items="raz4Items"
          v-model="raz4Selected"
          label="Odaberite razinu 4"
          single-line
          item-text="klasusRaz4"
          item-value="Razina4"
          return-object
          persistent-hint
          clearable
          dense
          outlined
          disabled
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row no-gutters class="pa-0" v-if="raz4">
      <v-col cols="12" sm="12" md="12" xs="12" lg="10" xl="10">
        <v-autocomplete
          :items="raz4Items"
          v-model="raz4Selected"
          label="Odaberite razinu 4"
          single-line
          item-text="klasusRaz4"
          item-value="Razina4"
          return-object
          persistent-hint
          clearable
          dense
          outlined
        ></v-autocomplete>
      </v-col>
    </v-row>

    <KlasusLevel5 :raz1Selected="raz1Selected" :raz2Selected="raz2Selected" :raz3Selected="raz3Selected" :raz4Selected="raz4Selected"/>
</div>
</template>

<script>


import KlasusService from '@/services/KlasusService'
import KlasusLevel5 from './KlasusLevel5.vue'
export default {
  name: 'klasuslevel4',
  props:['raz1Selected','raz2Selected','raz3Selected'],
  data () {
    return {
      msg: '',
      saving: false,
      raz4: false,
      raz4Items: [],
      raz4Selected: {},
      razUpit: {}
    }
  },
  async mounted () {
    await this.findRaz4()
  },
  methods: {
    async findRaz4() {
      let trazi = false

      if (Object.keys(this.raz1Selected).length > 0 && Object.keys(this.raz2Selected).length > 0 && Object.keys(this.raz3Selected).length > 0) {
        this.razUpit.Razina1 = this.raz1Selected.Razina1
        this.razUpit.Razina2 = this.raz2Selected.Razina2
        this.razUpit.Razina3 = this.raz3Selected.Razina3
        this.razUpit.onLevel = 4
        trazi = true
      }
      if (trazi) {
        console.log('Trazim na razini 4 ->', this.raz1Selected, this.raz2Selected, this.raz3Selected)
        await KlasusService.choose(this.razUpit).then(res => {
          if (res.data.klasusData) {
            this.raz4Items = res.data.klasusData
            this.raz4 = true
            console.log('this.raz4Items', this.raz4Items)
          }
        })
        .catch(err => {
          this.havealert = !this.havealert
          this.havemssgalert = 'Error on init Klasus Raz 4 ' + err
        })
      }
    }

  },
  computed: {

  },
  watch: {
    'raz3Selected'() {
      if (this.raz3Selected) {
        this.findRaz4()
      }
      if (!this.raz3Selected) {
        console.log('sad ga nemam razina 4')
        this.raz4 = false
      }
    }
  },
  components: {
    KlasusLevel5
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
